import { Routes, Route } from "react-router-dom";
import Login from "./pages/login/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import PrivateRoute from "./components/PrivateRoute";
import Report from "./pages/report/Report";
import PumpPort from "./pages/pumpPort/PumpPort";
import Pump from "./pages/pump/Pump";
import PumpTransaction from "./pages/pumpTransaction/PumpTransaction";
import User from "./pages/user/User";
import Role from "./pages/role/Role";
import Alert from "./pages/alert/Alert";
import Fuel from "./pages/fuel/Fuel";
import Shift from "./pages/shift/Shift";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-gb";

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/unauthorized" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoute requiredPermission="Reports">
              <Report />
            </PrivateRoute>
          }
        />
        <Route
          path="/pump-port"
          element={
            <PrivateRoute requiredPermission="Pump Port">
              <PumpPort />
            </PrivateRoute>
          }
        />
        <Route
          path="/pump"
          element={
            <PrivateRoute requiredPermission="Pump">
              <Pump />
            </PrivateRoute>
          }
        />
        <Route
          path="/pump-transaction"
          element={
            <PrivateRoute requiredPermission="Pump Transaction">
              <PumpTransaction />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-management"
          element={
            <PrivateRoute requiredPermission="User Management">
              <User />
            </PrivateRoute>
          }
        />
        <Route
          path="/role-management"
          element={
            <PrivateRoute requiredPermission="Role Management">
              <Role />
            </PrivateRoute>
          }
        />
        <Route
          path="/alert"
          element={
            <PrivateRoute requiredPermission="Alert">
              <Alert />
            </PrivateRoute>
          }
        />
        <Route
          path="/fuel"
          element={
            <PrivateRoute requiredPermission="Fuel">
              <Fuel />
            </PrivateRoute>
          }
        />
        <Route
          path="/employee-shift"
          element={
            <PrivateRoute requiredPermission="Employee Shift">
              <Shift />
            </PrivateRoute>
          }
        />
      </Routes>
    </LocalizationProvider>
  );
}

export default App;

